export const VUE_APP_API_BASE_URL = window.location.origin + '/backend';
// export const VUE_APP_API_BASE_URL = 'https://a3e9-122-179-130-125.ngrok-free.app';
// export const VUE_APP_API_BASE_URL = 'https://solutionwise.swypeuat.co.uk/backend';
// export const VUE_APP_API_BASE_URL = 'https://demo.swypetech.co.uk/backend';
// export const VUE_APP_API_BASE_URL = 'https://ck.swypetech.co.uk/backend';